import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import ThemeProvider from "@mui/material/styles/ThemeProvider";
import { trendratingCrmCustomTheme } from "./customTheme /theme";
import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from "react-router-dom";
import Login from "./pages/Login";
import { AuthProvider } from "./customHooks/useAuth";
import Overview from "./pages/Overview/Overview";
import Accounts from "./pages/Accounts/Accounts";
import Cloner from "./pages/Cloner/Cloner";
import { FilterProvider } from "./customHooks/useFIlters";
import { ManageAccountProvider } from "./customHooks/useManageAccount";
import { ProvideFeedback } from "./customHooks/useFeedback";
import Analytics from "./pages/Analytics/Analytics";

/**
 * Entry point dell'applicazione (bootstrap).
 *
 * Responsabilità:
 * - Creare il root React (React 18)
 * - Definire il router con React Router (data APIs)
 * - Registrare provider globali (theme, auth, feedback, router)
 * - Avviare (opzionalmente) la raccolta metriche tramite reportWebVitals
 */
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

/**
 * Router principale dell'app.
 *
 * Nota: le route figlie sotto "/" vengono renderizzate dentro <App /> tramite <Outlet />.
 * In questo progetto, <App /> è anche una "protected layout route" (effettua il guard auth).
 */
const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      { index: true, element: <Navigate to="overview" replace /> },

      {
        path: "overview",
        element: <Overview />,
        loader: async () => {
          document.title = "CRM - Overview";
          return null;
        },
      },
      {
        path: "accounts",
        element: (
          <ManageAccountProvider>
            <FilterProvider>
              <Accounts />
            </FilterProvider>
          </ManageAccountProvider>
        ),
        loader: async ({ params }) => {
          document.title = "CRM - Accounts";
          return params;
        },
      },
      {
        path: "cloner",
        element: <Cloner />,
        loader: async () => {
          document.title = "CRM - Cloner";
          return null;
        },
      },
      {
        path: "analytics",
        element: <Analytics />,
        loader: async () => {
          document.title = "CRM - Analytics";
          return null;
        },
      },
    ],
    loader: ({ params }) => params,
  },
  {
    path: "/login",
    element: <Login />,
    action: async () => {
      document.title = "CRM - Login";
    },
  },
]);
root.render(
  // <React.StrictMode>
  <ThemeProvider theme={trendratingCrmCustomTheme}>
    <ProvideFeedback>
      <AuthProvider>
        <RouterProvider router={router} />
      </AuthProvider>
    </ProvideFeedback>
  </ThemeProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
